<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择资产类型"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin">
      <a-card :bordered="false">
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :defaultExpandedKeys="defaultSelectedKeys"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :treeData="seatchTreeData"
          :draggable="false"
          @expand="onExpand"
          @select="select"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getAssetTypeTreeList, getAssetTypeTreeRole, getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      seatchTreeData: [],
      defaultSelectedKeys: [],
      selectedKeys: [],
      numberOfUpdates: 0,
      roleList: [],
      adminBoolean: false
    }
  },
  created () {
    // 获取资产类型
    this.getAssetType()
  },
  computed: {
    ...mapGetters(['assetAnlkl'])
  },
  methods: {
    ...mapActions(['handleAssetTypeCode']),
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    formateData (arr, id) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取资产类型
    async getAssetType () {
      this.loading = true
      await getAssetTypeTreeRole().then(res => {
        if (res.status === 0) {
          this.roleList = res.data.roleAssetTypeList
          this.adminBoolean = res.data.tag
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      await getAssetTypeTreeList().then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              if (item.typeCode) {
                item.code = item.typeCode
                item.key = item.typeCode
              }
              item.id = item.code
              item.scopedSlots = { title: 'custom' }
              item.children = this.formateData(item.children, item.id)
            })
            this.treeData = res.data
            this.defaultSelectedKeys = this.treeData[0].typeCode ? [this.treeData[0].typeCode] : [this.treeData[0].code]
            this.selectedKeys = this.treeData[0].typeCode ? [this.treeData[0].typeCode] : [this.treeData[0].code]
            console.log(this.assetAnlkl.anlkl)
            if (this.assetAnlkl.anlkl && this.assetAnlkl.anlkl !== '资产分类') {
              this.defaultSelectedKeys = [this.assetAnlkl.anlkl]
              this.selectedKeys = [this.assetAnlkl.anlkl]
            }
          } else {
            this.treeData = []
            this.defaultSelectedKeys = []
            this.selectedKeys = []
          }
          let codeData = this.treeData.length > 0 ? (this.treeData[0].typeCode ? this.treeData[0].typeCode : this.treeData[0].code) : '空'
          if (this.assetAnlkl.anlkl && this.assetAnlkl.anlkl !== '资产分类') {
            codeData = this.assetAnlkl.anlkl
          }
          this.seatchTreeData = this.treeData
          if (this.adminBoolean) {
            // 管理员
            this.handleAssetTypeCode({
              typeCode: codeData,
              numberOfUpdates: this.numberOfUpdates++
            })
          } else {
            // 非管理员，需要校验权限
            const index = this.roleList.findIndex(item => item.typeCode === codeData)
            if (index === -1) {
              this.handleAssetTypeCode({
                typeCode: '无权限',
                numberOfUpdates: this.numberOfUpdates++
              })
            } else {
              this.handleAssetTypeCode({
                typeCode: codeData,
                numberOfUpdates: this.numberOfUpdates++
              })
            }
          }
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let codeData = ''
        if (info.selectedNodes.length === 1) {
          codeData = info.selectedNodes[0].data.props.typeCode ? info.selectedNodes[0].data.props.typeCode : info.selectedNodes[0].data.props.code
        }
        if (this.adminBoolean) {
          // 管理员
          this.handleAssetTypeCode({
            typeCode: codeData,
            numberOfUpdates: this.numberOfUpdates++
          })
        } else {
          // 非管理员，需要校验权限
          const index = this.roleList.findIndex(item => item.typeCode === codeData)
          if (index === -1) {
            this.handleAssetTypeCode({
              typeCode: '无权限',
              numberOfUpdates: this.numberOfUpdates++
            })
          } else {
            this.handleAssetTypeCode({
              typeCode: codeData,
              numberOfUpdates: this.numberOfUpdates++
            })
          }
        }
      }
    },
    // 搜索设备分类
    queryDictData () {
      function fuzzySearch (str, obj) {
        var results = []
        for (var i = 0; i < obj.length; i++) {
          if (!obj[i].typeCode) {
            if (obj[i].name.indexOf(str) !== -1) {
              results.push(obj[i])
            }
          }
          if (obj[i].children) {
            results = results.concat(fuzzySearch(str, obj[i].children))
          }
        }
        return results
      }
      if (this.dimName) {
        this.seatchTreeData = fuzzySearch(this.dimName, this.treeData)
      } else {
        this.seatchTreeData = this.treeData
      }
      this.defaultSelectedKeys = this.seatchTreeData[0].typeCode ? [this.seatchTreeData[0].typeCode] : [this.seatchTreeData[0].code]
      this.selectedKeys = [this.seatchTreeData[0].code]
      this.handleAssetTypeCode({
        typeCode: this.seatchTreeData.length > 0 ? (this.seatchTreeData[0].typeCode ? this.seatchTreeData[0].typeCode : this.seatchTreeData[0].code) : '空',
        numberOfUpdates: this.numberOfUpdates++
      })
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
</style>
